import { render } from "./showQR.vue?vue&type=template&id=1a484888&scoped=true&ts=true"
import script from "./showQR.vue?vue&type=script&lang=ts"
export * from "./showQR.vue?vue&type=script&lang=ts"

import "./showQR.vue?vue&type=style&index=0&id=1a484888&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a484888"]])

export default __exports__